module.exports = __webpack_public_path__ + "static/image3-5275df633f034587a746f28fe2de8a9c.jpg";